export default class VerordnungDto {

  constructor(json) {
    if (json) {
      this.json = json
      this.id = json.id;
      this.srNummer = json.srNummer;
      this.art = json.art;
      this.geltungsdauerVon = json.geltungsdauerVon;
      this.geltungsdauerBis = json.geltungsdauerBis;
      this.stornierungsdatum = json.stornierungsdatum;
      this.status = json.status;
      this.link = json.link;
      this.startPerioden = json.startPerioden;
      this.dauerPeriode = json.dauerPeriode;
      this.anzahlZeit = json.anzahlZeit;
      this.perioden = json.perioden;
      this.berechnungsart = json.berechnungsart;
      this.referenzjahr = json.referenzjahr;
      this.referenzart = json.referenzart;
      this.schwellwertAktiv = json.schwellwertAktiv;
      this.schwellwert = json.schwellwert;
      this.verbrauchergruppen = json.verbrauchergruppen;
      this.briefversandPflicht = json.briefversandPflicht;
      this.aktiviertOn = json.aktiviertOn;
      this.aktiviertBy = json.aktiviertBy;
      this.storniertOn = json.storniertOn;
      this.storniertBy = json.storniertBy;
    } else {
      this.json = {}
      this.perioden = []
      this.verbrauchergruppen = []
      this.referenzjahr = []
    }
  }

  get kontArt() {
    return 'art.' + this.art.toLowerCase()
  }

  get kontStatus() {
    return 'status.' + this.status.toLowerCase()
  }

  get geltungsdauer() {
    return [
      this._toLocalDateString(this.geltungsdauerVon),
      this._toLocalDateString(this.stornierungsdatum ?? this.geltungsdauerBis)
    ].filter(v => v).join(' - ')
  }

  get berechnungsartMain() {
    return this.berechnungsart?.split('_')[0]
  }

  get berechnungsartSub() {
    return this.berechnungsart?.split('_')[1]
  }

  _toLocalDateString(date) {
    return new Date(date).toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  }
}
